import { AppDispatch, RootState } from '../redux/store';
import { updateParentsWithChildren } from './reducers/documentsSlice';

// This Action function is dispatched on UN-GROUPING, once this is called it checks the documents for parent key, 
// if the parent key exist and is not euql to the value passed as payload then it  runs another dispatch to a
//  reducer called updateparentsWithChildren to remove the parent id from the array stored in store 
// parentswithchildren   
export const checkAndRemoveParentFromDocuments = (parentId: string) => {
  return (dispatch: AppDispatch, getState: () => RootState) => {
    const state = getState();  
    let count = 0;

    //check if any children left with parent key equal to the payload that is parentId;
    Object.keys(state.documentsData).forEach((clientId) => {
      const documents = state.documentsData[clientId];
      documents.forEach((eachDocument) => {
        if (eachDocument.parent === parentId) {
          count++;
        }
      });
    });

    if (count === 0) { //if count is 0 that means a child does not exist hence remove the parentId from the store state that is parentswithchildren
      dispatch(updateParentsWithChildren(parentId));
    }
  };
};

